<template>
  <div v-if="show" class="info-modal-overlay" @click="$emit('close')">
    <div class="info-modal" @click.stop>
      <div class="info-modal-header">
        <h3 class="info-title">Function Introduction</h3>
        <button class="info-close-button" @click="$emit('close')">×</button>
      </div>
      <div class="info-modal-content">
        <!-- Priority模式内容 -->
        <template v-if="mode === 'priority'">
          <div class="info-item">
            <h4 class="info-section-title">UBGS ratio:</h4>
            <p class="info-content">The ratio of the UBGS area to the built-up area of the city.</p>
          </div>
          <div class="info-item">
            <h4 class="info-section-title">Urban population:</h4>
            <p class="info-content">The population within the built-up area of the city.</p>
          </div>
          <div class="info-item">
            <h4 class="info-section-title">Over threshold:</h4>
            <p class="info-content">The proportion of cells within a city that can reach the threshold of accessibility for promoting wellbeing in the overall city. For the quantification of this indicator, please refer to the 'Results' section of the article.</p>
          </div>
          <div class="info-item">
            <h4 class="info-section-title">MESH:</h4>
            <p class="info-content">MESH (Effective Mesh Size) is an indicator for measuring landscape connectivity, representing the size of an 'equivalent continuous mesh' that standardizes the area of the entire landscape. This indicator is used to measure the degree of fragmentation of the city. The value range of MESH is from 1 to the number of patches within the city. The closer the MESH is to 1, the more continuous the urban form is. The higher the MESH value is, the more fragmented the urban form will be.</p>
          </div>
        </template>
        
        <!-- A-E模式内容 -->
        <template v-else>
          <div class="info-item">
            <p class="info-content">This study adopts a standardized distance based on deviation from the scaling law here to represent the development differences in the UBGS accessibility and equality. When the accessibility or equality of individual cities exceeds the overall scaling rate, the city is defined as high accessibility or high equality. Click on a single city to see the spatial distribution of UBGS accessibility.</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue';

export default {
  name: 'LegendInfo',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'priority'
    }
  },
  emits: ['close'],
  setup(props, { emit }) {
    // ESC键退出功能
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && props.show) {
        emit('close');
      }
    };

    onMounted(() => {
      document.addEventListener('keydown', handleKeyDown);
    });

    onUnmounted(() => {
      document.removeEventListener('keydown', handleKeyDown);
    });

    return {};
  }
};
</script>

<style scoped>
/* 功能介绍弹窗样式 - 参考IntroPanel设计 */
.info-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.info-modal {
  width: 500px;
  max-height: 70vh;
  background: rgba(250, 250, 250, 0.74);
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(143, 143, 143, 0.3);
  padding: 12px;
  box-sizing: border-box;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
}

.info-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.info-title {
  font-size: 16px;
  font-weight: 600;
  color: rgb(20, 20, 20);
  text-align: left;
  margin: 0;
}

.info-close-button {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  background: rgba(92, 91, 91, 0.2);
  border: none;
  border-radius: 50%;
  font-size: 16px;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.info-close-button:hover {
  background: rgba(255, 255, 255, 0.3);
}

.info-modal-content {
  flex: 1;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100% - 40px);
  padding-right: 8px;
  margin-top: 0px;
}

/* 滚动条样式 - 与IntroPanel一致 */
.info-modal-content::-webkit-scrollbar {
  width: 4px;
  background: transparent;
}

.info-modal-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 2px;
  margin: 20px 2px 5px 0;
}

.info-modal-content::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 2px;
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.info-modal-content:hover::-webkit-scrollbar-thumb {
  background: rgba(143, 143, 143, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.info-modal-content:hover::-webkit-scrollbar-thumb:hover {
  background: rgba(143, 143, 143, 0.7);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.info-item {
  margin-bottom: 12px;
  padding-bottom: 8px;
}

.info-item:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.info-section-title {
  font-size: 14px;
  font-weight: 600;
  color: rgb(20, 20, 20);
  margin: 0 0 6px 0;
  text-align: left;
}

.info-content {
  font-size: 12px;
  line-height: 1.35;
  color: rgba(34, 34, 34, 0.95);
  text-align: left;
  font-weight: 400;
  margin: 0;
}
</style> 